import React, { useState, useEffect } from 'react';
import './styles.scss';
import StepperImage from "../../assets/images/stepperImage.svg";
import TestTube from "../../assets/images/test-tube.svg";
import Stepper from "./Components/Stepper";
const AccountProfile = () => {
    return (
        <>
            <div className="acc-pro-cont">
                <div className="account-profile-container">
                    <div className="inner-container">
                        <div className="header-font">Hello, Promise!</div>
                        <div className="sub-header-font">Welcome to your dashboard</div>
                        <div className="order-font">ORDERS IN PROGRESS</div>
                        <div className="order-container-out">
                            <div className="order-content">
                                <div className="left-content">
                                    <div className="left-cont-out">
                                        <div className="head-font">You have no tests in progress</div>
                                        <div className="sub-header-font">Activate your health test and collect your sample</div>
                                        <div className="test-button-out">
                                            <div className="test-button"><span>Place a test order</span></div>
                                        </div>

                                    </div>
                                </div>
                                <div className="right-content">
                                    <Stepper />
                                </div>
                            </div>
                        </div>
                        <div className="recent-font">RECENT LAB RESULTS</div>
                        <div className="recent-lab-out-cont">
                            <img src={TestTube} alt="TestTube" />
                            <div className="first-row-font">You currently don’t have any recent lab results</div>
                            <div className="second-row-font">Order a new test and eaily get your delivery</div>
                            <div className="test-button-out">
                                <div className="test-button"><span>View Diferent Tests</span></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default AccountProfile;